<template>
<div>
  <el-row :gutter="10">
    <el-col :span="2" :lg="2" :md="3">
      <el-button type="success" icon="el-icon-plus" size="medium" @click="addThird">
        Nuevo
      </el-button>
    </el-col>
    <el-col :span="8">
      <el-input
          placeholder="Número de documento"
          v-model="searchInput"
          clearable
          size="medium"
          @clear="searchInput = null; getAllAction()"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </el-col>
    <el-col :span="8">
      <el-button type="primary" icon="el-icon-search" size="medium" :loading="loading" @click="getAllAction()">
        Buscar
      </el-button>
      <el-button type="warning" icon="el-icon-download" size="medium" @click="modalOpen = true">
        Descargar
      </el-button>
    </el-col>
  </el-row>
  <el-row :gutter="10">
    <el-col :span="24">
      <el-table :data="all" v-loading="loading" height="530">
        <el-empty slot="empty" description="No hay datos"></el-empty>
        <el-table-column label="Documento" prop="document" sortable></el-table-column>
        <el-table-column label="Nombre" prop="name" sortable></el-table-column>
        <el-table-column label="Telefono" prop="phone" sortable></el-table-column>
        <el-table-column label="Tipo" width="250px">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.client == 1"
              size="small"
              type="success"
              style="margin-right: 5px">
              Cliente
            </el-tag>
            <el-tag
              v-if="scope.row.seller == 1"
              size="small"
              type="warning"
              style="margin-right: 5px">
              Vendedor
            </el-tag>
            <el-tag v-if="scope.row.provider == 1" size="small">
              Proveedor
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="100px" align="right">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Editar"
              placement="top"
            >
              <el-button
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
                icon="el-icon-edit"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Eliminar"
              placement="top"
            >
              <el-button
                :disabled="scope.row.used != 0"
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                icon="el-icon-delete"
                circle
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
  <el-row :gutter="10">
    <el-col :span="24">
      <div
      v-if="all.length > 0"
      class="pagination-box animated fadeInRight"
      style="text-align: end; padding-top: 10px"
      >
      <el-pagination
        layout="total, prev, pager, next"
        :page-size="pageSize"
        :total="totalRows"
        @current-change="handleCurrentPage"
      ></el-pagination>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
    };
  },
  created() {
    this.getAllAction()
  },
  computed: {
    ...mapGetters('third', ['all','search', 'loading', 'totalRows', 'pageSize']),
    searchInput: {
      get() { return this.search },
      set(value) { this['third/SET_SEARCH'](value) }
    },
  },
  methods: {
    ...mapMutations(['setRightMenu','third/SET_SEARCH']),
    ...mapActions('third',['getAllAction', 'deleteAction']),
    addThird(){
      this.setRightMenu({
        componentActive: 'third-form-component',
        drawer: true,
        data: {
          icon: 'account',
          title: 'Agregar tercero',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    handleCurrentPage(val) {
      this.getAllAction(val);
    },
    handleEdit(index, row) {
       this.setRightMenu({
        componentActive: 'third-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Editar producto',
          btnRemove: false,
          field_id: row.id,
          hidden_btn: true,
          edit: true,
        }
      })
    },
  }
}
</script>